import { IABTesting, IAudienceDeal, IBidderLabel } from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { IFlexibleBiddingThreshold } from '~/src/dash/api/types/flexible_bidding';

export enum EHeaderBidder_InventoryType {
  HeaderBidder_INVENTORY_TYPE_UNKNOWN = 0,
  HeaderBidder_INVENTORY_TYPE_NONE = 1,
  HeaderBidder_INVENTORY_TYPE_SHARED_NO_BACKFILL = 2,
  HeaderBidder_INVENTORY_TYPE_SHARED_WITH_BACKFILL = 3,
}

export enum EHeaderBidder_TargetedAdBreak {
  HeaderBidder_TARGETED_ADBREAK_ALL = 0,
  HeaderBidder_TARGETED_ADBREAK_FIRST = 1,
  HeaderBidder_TARGETED_ADBREAK_LAST = 2,
}

export enum EHeaderBidder_PositionTargeting {
  HeaderBidder_PositionTargeting_ALL = 0,
  HeaderBidder_PositionTargeting_PREROLL = 1,
  HeaderBidder_PositionTargeting_MIDROLL = 2,
  HeaderBidder_PositionTargeting_POSTROLL = 3,
}

export enum EHeaderBidder_DealAtTargeting {
  HeaderBidder_DealAtTargeting_None = 0,
  HeaderBidder_DealAtTargeting_First_Price = 1,
  HeaderBidder_DealAtTargeting_Second_Price_Plus = 2,
  HeaderBidder_DealAtTargeting_Fixed_Price = 3,
}

export enum EHeaderBidder_PodSequenceTargeting {
  HeaderBidder_PodSequenceTargeting_ANYPOD = 0,
  HeaderBidder_PodSequenceTargeting_FIRSTPOD = 1,
  HeaderBidder_PodSequenceTargeting_LASTPOD = 2,
  HeaderBidder_PodSequenceTargeting_FIRSTANDLASTPOD = 3,
}

export enum EHeaderBidder_ShareOfVoiceType {
  HeaderBidder_ShareOfVoiceType_UNKNOWN = 0,
  HeaderBidder_ShareOfVoiceType_POD = 1,
  HeaderBidder_ShareOfVoiceType_POD_DURATION = 2,
}

interface IHeaderBidderInventoryTypesMap {
  [key: string]: EHeaderBidder_InventoryType;
}

export const TitleToHeaderBidderInventoryTypesMap: IHeaderBidderInventoryTypesMap = {
  None: EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_NONE,
  'Shared With No Backfill':
    EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_SHARED_NO_BACKFILL,
  'Shared With Backfill':
    EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_SHARED_WITH_BACKFILL,
};

export const HeaderBidderInventoryTypesToTitleMap: { [key: number]: string } = {
  1: 'None',
  2: 'Shared With No Backfill',
  3: 'Shared With Backfill',
};

export type HeaderBiddersAPIKey =
  | 'ID'
  | 'CreatedAt'
  | 'UpdatedAt'
  | 'DeletedAt'
  | 'Name'
  | 'Bidder'
  | 'Active'
  | 'SuperOnly'
  | 'Params'
  | 'Priority'
  | 'SiteIDS'
  | 'ChannelGroupIDS'
  | 'CampaignIDS'
  | 'AudienceDeals'
  | 'HeaderBidderPastWeekSummary'
  | 'UIBidderType'
  | 'abTests'
  | 'FlexibleBiddingEnabled'
  | 'FlexibleBiddingThresholds'
  | 'EnableSpotxBidderAssociation'
  | 'EnableMagniteCTVBidderAssociation'
  | 'PastWeekAverageCPM'
  | 'PastWeekBidRequests'
  | 'PastWeekImpressions'
  | 'PastWeekImpressionsTrend'
  | 'PastWeekRevenue'
  | 'PastWeekRevenueTrend';

interface IHeaderBidderPastWeekSummary {
  PastWeekAverageCPM: number;
  PastWeekBidRequests: number;
  PastWeekImpressions: number;
  PastWeekImpressionsTrend: number;
  PastWeekRevenue: number;
  PastWeekRevenueTrend: number;
}

export interface IHeaderBidderListInfo {
  ID: string;
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: string;
  Name: string;
  Bidder: string;
  Active: EBool;
  SuperOnly: boolean;
  Params: string;
  Priority: number;
  SiteIDS?: number[];
  ChannelGroupIDS?: number[];
  CampaignIDS?: number[];
  AudienceDeals?: IAudienceDeal[];
  HeaderBidderPastWeekSummary: IHeaderBidderPastWeekSummary;
  UIBidderType: string;
  abTests: IABTesting[];
  FlexibleBiddingEnabled: EBool;
  FlexibleBiddingThresholds: IFlexibleBiddingThreshold[];
  EnableSpotxBidderAssociation: EBool;
  EnableMagniteCTVBidderAssociation: EBool;
  PastWeekAverageCPM?: number | null;
  PastWeekBidRequests?: number | null;
  PastWeekImpressions?: number | null;
  PastWeekImpressionsTrend?: number | null;
  PastWeekRevenue?: number | null;
  PastWeekRevenueTrend?: number | null;
  BidderLabels?: IBidderLabel[];
  BidderLabelsArray?: string[];
}
